import { post, del, isCancelError, generateClient } from "aws-amplify/api";
import awsconfig from "../../aws-exports";
import {
  isCancelError as storageIsCancelError,
  uploadData,
  getUrl,
} from "aws-amplify/storage";

const client = generateClient();

export async function requestDocumentUpload(dispatch, payload) {
  const {
    documentType,
    documentNumber,
    documentPage,
    documentPassword,
    documentDate,
    reason,
    file,
    coordinates,
    parentStampingID,
  } = payload;

  try {
    dispatch({ type: "REQUEST_UPLOAD_DOCUMENT" });

    const key = `emeterai/${file.name}`;

    const upload = uploadData({
      path: ({ identityId }) => `private/${identityId}/${key}`,
      data: file,
      options: {
        contentType: file.type,
        onProgress: (progress) => {
          dispatch({
            type: "UPLOAD_DOCUMENT_PENDING",
            payload: { progress, upload },
          });
        },
      },
    });

    const result = await upload.result;

    dispatch({
      type: "UPLOAD_DOCUMENT_PENDING",
      payload: { storageRequest: null },
    });

    const input = {
      documentType: documentType,
      documentNumber: documentNumber,
      documentDate: documentDate,
      reason: reason,
      documentPage: documentPage,
      documentPassword: documentPassword,
      coordinates: {
        visLLX: coordinates.visLLX,
        visLLY: coordinates.visLLY,
        visURX: coordinates.visURX,
        visURY: coordinates.visURY,
      },
      parentStampingID,
    };

    if (result.path) {
      input.file = {
        key,
        bucket: awsconfig.aws_user_files_s3_bucket,
        region: awsconfig.aws_user_files_s3_bucket_region,
      };
    }

    const req = post({
      apiName: "emeterai",
      path: "/upload",
      options: {
        body: input,
      },
    });

    await dispatch({
      type: "CREATE_DOCUMENT_PENDING",
      payload: { req },
    });

    const { body } = await req.response;

    const res = await body.json();

    dispatch({
      type: "CREATE_DOCUMENT_PENDING",
      payload: { uploadRequest: null },
    });

    const document = res.data;
    dispatch({
      type: "UPLOAD_DOCUMENT_SUCCESS",
      payload: { document },
    });
  } catch (error) {
    if (storageIsCancelError(error)) {
      dispatch({
        type: "UPLOAD_DOCUMENT_ERROR",
        error: null,
      });
    } else if (isCancelError(error)) {
      dispatch({
        type: "UPLOAD_DOCUMENT_ERROR",
        error: null,
      });
    } else {
      dispatch({ type: "UPLOAD_DOCUMENT_ERROR", error });
    }
  }
}

export async function requestListEmeteraiStampings(dispatch, payload) {
  const {
    page,
    createdAt = "",
    limit = 25,
    updatedAt,
    nextToken = "start",
    status,
    sortDirection = "DESC",
  } = payload;

  try {
    dispatch({
      type: `REQUEST_LIST_EMETERAI_STAMPING`,
      payload: { request: null, page },
    });

    const params = {
      limit,
      updatedAt,
      status,
      sortDirection,
    };

    if (createdAt) {
      params.createdAt = createdAt;
    }

    let items = [];
    let token = "start";
    if (nextToken) {
      token = nextToken;
    }

    while (token && items.length === 0) {
      if (token && token !== "start") {
        params.nextToken = token;
      }

      const request = client.graphql({
        query: emeteraiStampingsByStatusUpdatedAt,
        variables: params,
      });
      dispatch({
        type: "REQUEST_LIST_EMETERAI_STAMPING",
        payload: { request },
      });

      // eslint-disable-next-line no-await-in-loop
      const res = await request;
      items = [...items, ...res.data.emeteraiStampingsByStatusUpdatedAt.items];
      token = res.data.emeteraiStampingsByStatusUpdatedAt.nextToken;
    }

    dispatch({
      type: `LIST_EMETERAI_STAMPING_SUCCESS`,
      payload: {
        stampings: items,
        nextToken: token,
        nextPage: page + 1,
      },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "LIST_EMETERAI_STAMPING_CANCEL",
      });
    } else {
      dispatch({ type: `LIST_EMETERAI_STAMPING_ERROR`, error });
    }
  }
}

export async function requestListEmeteraiStampingsByOwner(dispatch, payload) {
  const {
    page,
    createdAt = "",
    limit = 25,
    updatedAt,
    nextToken = "start",
    owner,
    sortDirection = "DESC",
  } = payload;

  try {
    dispatch({
      type: `REQUEST_LIST_EMETERAI_STAMPING`,
      payload: { request: null, page },
    });

    const params = {
      limit,
      updatedAt,
      owner,
      sortDirection,
    };

    if (createdAt) {
      params.createdAt = createdAt;
    }

    let items = [];
    let token = "start";
    if (nextToken) {
      token = nextToken;
    }

    while (token && items.length === 0) {
      if (token && token !== "start") {
        params.nextToken = token;
      }

      const request = client.graphql({
        query: emeteraiStampingsByOwnerUpdatedAt,
        variables: params,
      });
      dispatch({
        type: "REQUEST_LIST_EMETERAI_STAMPING",
        payload: { request },
      });

      // eslint-disable-next-line no-await-in-loop
      const res = await request;
      items = [...items, ...res.data.emeteraiStampingsByOwnerUpdatedAt.items];
      token = res.data.emeteraiStampingsByOwnerUpdatedAt.nextToken;
    }

    dispatch({
      type: `LIST_EMETERAI_STAMPING_SUCCESS`,
      payload: {
        stampings: items,
        nextToken: token,
        nextPage: page + 1,
      },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "LIST_EMETERAI_STAMPING_CANCEL",
      });
    } else {
      dispatch({ type: `LIST_EMETERAI_STAMPING_ERROR`, error });
    }
  }
}

export async function requestGetEmeteraiStamping(dispatch, payload) {
  try {
    const { id } = payload;

    dispatch({ type: "REQUEST_GET_EMETERAI_STAMPING" });

    const params = {
      id,
    };

    const res = await client.graphql({
      query: getEmeteraiStamping,
      variables: params,
    });

    const emeteraiStamping = res.data.getEmeteraiStamping;

    dispatch({
      type: "GET_EMETERAI_STAMPING_SUCCESS",
      payload: { emeteraiStamping },
    });
  } catch (error) {
    dispatch({ type: "GET_EMETERAI_STAMPING_ERROR", error });
  }
}

export async function requestDocumentDownload(dispatch, payload) {
  const { key } = payload;
  try {
    dispatch({ type: "REQUEST_DOWNLOAD_DOCUMENT" });

    const urlResult = await getUrl({
      path: ({ identityId }) => `private/${identityId}/${key}`,
    });

    const result = urlResult.url.href;

    dispatch({
      type: "DOWNLOAD_DOCUMENT_SUCCESS",
      payload: { downloadedDocument: result },
    });
  } catch (error) {
    dispatch({ type: "DOWNLOAD_DOCUMENT_ERROR", error });
  }
}

export async function requestRetryStamp(dispatch, payload) {
  try {
    const { id } = payload;

    dispatch({ type: "REQUEST_RETRY_STAMP", payload: { request: null } });

    const request = post({
      apiName: "emeterai",
      path: "/retry",
      options: {
        body: { id },
      },
    });
    dispatch({ type: "REQUEST_RETRY_STAMP", payload: { request } });

    const { body } = await request.response;
    const res = await body.json();

    dispatch({
      type: "RETRY_STAMP_SUCCESS",
      payload: { retryStamp: res.data },
    });
  } catch (error) {
    dispatch({ type: "RETRY_STAMP_ERROR", error });
  }
}

export async function clearUploadDocument(dispatch) {
  dispatch({ type: "CLEAR_UPLOAD_DOCUMENT" });
}

export async function clearRetryStamp(dispatch) {
  dispatch({ type: "CLEAR_RETRY_STAMP" });
}

export async function requestDeleteEmeteraiFile(dispatch, payload) {
  try {
    const { id } = payload;

    dispatch({ type: "REQUEST_DELETE_EMETERAI_FILE", payload: { request: null } });

    const request = del({
      apiName: "emeterai",
      path: `/file/${id}`,
    });
    dispatch({ type: "REQUEST_DELETE_EMETERAI_FILE", payload: { request } });

    const { body } = await request.response;
    const res = await body.json();

    dispatch({
      type: "DELETE_EMETERAI_FILE_SUCCESS",
      payload: { deletedFile: res.data },
    });
  } catch (error) {
    dispatch({ type: "DELETE_EMETERAI_FILE_ERROR", error });
  }
}

export async function clearDeleteStamping(dispatch) {
  dispatch({ type: "CLEAR_DELETE_STAMPING" });
}

const emeteraiStampingsByStatusUpdatedAt = /* GraphQL */ `
  query EmeteraiStampingsByStatusUpdatedAt(
    $status: PaymentStatus
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelEmeteraiStampingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    emeteraiStampingsByStatusUpdatedAt(
      status: $status
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serialNumber
        file {
          bucket
          region
          key
        }
        documentType
        documentNumber
        documentPage
        documentDate
        status
        error
        coordinates {
          visLLX
          visLLY
          visURX
          visURY
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

const emeteraiStampingsByOwnerUpdatedAt = /* GraphQL */ `
  query EmeteraiStampingsByOwnerUpdatedAt(
    $owner: String
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelEmeteraiStampingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    emeteraiStampingsByOwnerUpdatedAt(
      owner: $owner
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serialNumber
        file {
          bucket
          region
          key
        }
        documentType
        documentNumber
        documentPage
        documentDate
        status
        error
        owner
        coordinates {
          visLLX
          visLLY
          visURX
          visURY
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

const getEmeteraiStamping = /* GraphQL */ `
  query GetEmeteraiStamping($id: ID!) {
    getEmeteraiStamping(id: $id) {
      id
      serialNumber
      file {
        bucket
        region
        key
      }
      documentType
      documentNumber
      documentPage
      documentDate
      status
      error
      coordinates {
        visLLX
        visLLY
        visURX
        visURY
      }
      createdAt
      updatedAt
    }
  }
`;
